module.exports = __webpack_public_path__ + "static/318299798_666023451860760_4193496186628618653_n.jpg-1671186392897-5a06286337da7f193339d25f8f9bbdc7.webp";